import { apiMappings, argPath } from 'constant/ApiConstants';

/**
 * Constructs the base path for ARG API requests.
 *
 * @returns {string} The base path for ARG API requests.
 */
export const baseArgPath = () => {
  const apiKey = getApiPathKey();
  return `${apiMappings[apiKey]}${argPath}`;
};

const getApiPathKey = () => {
  const host = window.location.hostname;
  return (
    Object.keys(apiMappings).find(key => host.includes(key)) || 'localhost'
  );
};
